import { useEffect, useState } from 'react';
import { PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { userLayoutsAPI } from '../../services/userLayoutsAPI.js';
export const useVehicleDetailsLayout = ({ userId, defaultBlocks }) => {
    const [layoutBlocks, setLayoutBlocks] = useState(defaultBlocks);
    const [layoutLoaded, setLayoutLoaded] = useState(false);
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 2 } }), useSensor(TouchSensor, { activationConstraint: { delay: 60, tolerance: 3 } }));
    useEffect(() => {
        let mounted = true;
        const loadLayout = async () => {
            try {
                const res = await Promise.race([
                    userLayoutsAPI.getVehicleDetailsLayout(userId),
                    new Promise((resolve) => setTimeout(() => resolve({ data: { blocks: defaultBlocks } }), 5000)),
                ]);
                const blocks = res?.data?.blocks || [];
                const normalized = Array.isArray(blocks) ? blocks.filter(Boolean) : [];
                if (!mounted)
                    return;
                const merged = [
                    ...normalized.filter((blockId) => defaultBlocks.includes(blockId)),
                    ...defaultBlocks.filter((blockId) => !normalized.includes(blockId)),
                ];
                setLayoutBlocks(merged.length ? merged : defaultBlocks);
            }
            catch (_error) {
                if (mounted)
                    setLayoutBlocks(defaultBlocks);
            }
            finally {
                if (mounted)
                    setLayoutLoaded(true);
            }
        };
        loadLayout();
        return () => {
            mounted = false;
        };
    }, [userId, defaultBlocks]);
    const handleLayoutDragEnd = async (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id)
            return;
        const previous = layoutBlocks;
        const oldIndex = previous.indexOf(active.id);
        const newIndex = previous.indexOf(over.id);
        if (oldIndex < 0 || newIndex < 0)
            return;
        const next = arrayMove(previous, oldIndex, newIndex);
        setLayoutBlocks(next);
        try {
            await userLayoutsAPI.saveVehicleDetailsLayout(userId, next);
        }
        catch (error) {
            setLayoutBlocks(previous);
            throw error;
        }
    };
    return { sensors, layoutBlocks, layoutLoaded, handleLayoutDragEnd };
};
